import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Meeting from '@/components/Meeting/Meeting';
import useCalendar from '@/hooks/useCalendar';
import useMeetingMedia from '@/hooks/useMeetingMedia';
import useMeetings from '@/hooks/useMeetings';
import useUsers from '@/hooks/useUsers';
import PageContainer from '@/pages/PageContainer';
import { useSelectedMeetingsActions } from '@/store/selectedMeetingsStore';

const MeetingPage = () => {
  const { meetingId } = useParams<{ meetingId?: string }>();
  const { meeting, meetingInfo } = useMeetings(undefined, undefined, meetingId);
  const { meetingRecordingUrl, meetingTranscriptUrl } = useMeetingMedia(meeting?.botId);
  const { event, eventLoading } = useCalendar(undefined, undefined, meeting?.calendarEventId);
  const { usersList } = useUsers();
  const { setSelectedMeetings, clearSelectedMeetings } = useSelectedMeetingsActions();

  useEffect(() => {
    if (meetingInfo && meeting) {
      setSelectedMeetings([
        {
          id: meeting.id,
          transcript: meeting.transcript,
          title: meetingInfo.title,
          thumbnail: meetingInfo.thumbnail,
          startTime: meetingInfo.startTime
        }
      ]);
    }
    return () => {
      clearSelectedMeetings();
    };
  }, [meetingInfo, meeting]);

  return (
    <PageContainer>
      <Meeting
        event={event}
        eventLoading={eventLoading}
        usersList={usersList}
        meetingRecordingUrl={meetingRecordingUrl}
        meetingTranscriptUrl={meetingTranscriptUrl}
        meeting={meeting || undefined}
      />
    </PageContainer>
  );
};

export default MeetingPage;
